import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { TitleService } from './shared/services/title.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { NAME_AFFILIATE_COOKIES, NAME_AFFILIATE_PARAM } from '@smmof/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  /**
   * Constructor
   */
  constructor(
    private titleService: TitleService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.activatedRoute.queryParamMap.subscribe(params => {
        const ac = params.get(NAME_AFFILIATE_PARAM)
          console.log('Referral Code:', params.get(NAME_AFFILIATE_PARAM));
        if (ac) {
          const cookieName = encodeURIComponent(NAME_AFFILIATE_COOKIES);
          const cookieValue = encodeURIComponent(ac);
          const domain = `.${environment.baseDomain}`;
          const path = '/';
          const expires = '';

          document.cookie = `${cookieName}=${cookieValue}; path=${path}; domain=${domain}${expires}`;
        }
      });
    });

    document.body.setAttribute('smmof-version', environment.version);
    this.titleService.init();
  }
}
